const forgotPassword = {
  title: "Gleymt lykilorð",
  subtitle: "Sláðu inn netfangið þitt og við sendum þér leiðbeiningar um að endurstilla lykilorðið.",
  emailLabel: "Netfang",
  emailPlaceholder: "netfang@example.com",
  sending: "Sendi...",
  submit: "Senda endurstillingarleiðbeiningar",
  backToLogin: "Til baka í innskráningu",
  emailSent: {
    title: "Tölvupóstur sendur",
    messagePrefix: "Ef notandi er skráður með netfangið",
    messageSuffix: " færðu leiðbeiningar um að endurstilla lykilorðið send í pósti innan skamms.",
    checkEmail: "Athugaðu tölvupóstinn þinn og fylgdu leiðbeiningunum til að endurstilla lykilorðið.",
  },
  errors: {
    sendFailed: "Ekki tókst að senda endurstillingarpóst",
  },
};

export default forgotPassword;
